import { frontendURL } from '../../../../helper/URLHelper';

const PipelineSettings = () => import('./PipelineSettings.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/pipelines'),
      name: 'settings_pipelines_list',
      meta: {
        permissions: ['administrator'],
      },
      component: PipelineSettings,
    },
  ],
};
